import Colors from 'src/core/utils/Colors';
import Dimens from 'src/core/utils/Dimens';
import Fonts from 'src/core/utils/Fonts';

const baseBodyStyle = {
	fontFamily: Fonts.barlow,
	fontSize: Dimens.fontSize16,
	lineHeight: Dimens.lineHeight24,
	color: Colors.gray800,
	marginBottom: Dimens.padding8,
};

export const tagsStyles = {
	body: baseBodyStyle,
	strong: {
		...baseBodyStyle,
		fontFamily: Fonts.barlowMedium,
	},
	italic: {
		...baseBodyStyle,
		fontStyle: 'italic',
	},
	del: {
		...baseBodyStyle,
		textDecorationLine: 'line-through',
	},
	a: {
		...baseBodyStyle,
		textDecorationLine: 'underline',
		color: Colors.green,
	},
	h1: {
		fontFamily: Fonts.ptSerif,
		fontSize: Dimens.fontSize20,
		fontWeight: undefined,
		marginBottom: Dimens.padding8,
	},
	h2: {
		fontFamily: Fonts.ptSerif,
		fontSize: Dimens.fontSize16,
		fontWeight: undefined,
		marginBottom: Dimens.padding8,
	},
	h3: {
		fontFamily: Fonts.ptSerif,
		marginBottom: Dimens.padding8,
		fontSize: Dimens.fontSize16,
		fontWeight: undefined,
	},
	li: {
		...baseBodyStyle,
		paddingLeft: Dimens.padding14,
	},
	ol: {
		...baseBodyStyle,
		paddingLeft: Dimens.padding14,
	},
	ul: {
		...baseBodyStyle,
		paddingLeft: Dimens.padding14,
	},
	span: {},
};
